import {http} from '../http'
import * as corePhotos from '../../coreApi/photos'
import {APIResponse, PagedCollectionResponse} from '../types'
import {ResourceID, Photo} from '../../../types'
import {handleError} from '../handleError'
import {API_URL} from '../../../constants'

interface Params {
  clientID: ResourceID
  pageNumber: number
  pageSize: number
  albumID: ResourceID | null
}

type ResolvedReturn = APIResponse<PagedCollectionResponse<Photo>>

export interface ServiceMethod {
  (params: Params): Promise<ResolvedReturn>
}

const ERROR_PATH = 'api.photos.getPhotos()'
const GENERIC_ERROR =
  'Something went wrong while getting your photos. Please try again.'

export const fetchAlbumPhotos: ServiceMethod = async ({
  clientID,
  pageNumber,
  pageSize,
  albumID,
}) => {
  let resolvedReturn: ResolvedReturn

  try {
    const rawParamMap = {
      ClientID: parseInt(clientID, 10),
      PageNumber: pageNumber,
      PageSize: pageSize,
      AlbumID: albumID ? parseInt(albumID, 10) : null,
    }

    const response = await corePhotos.list(http, rawParamMap)

    if (!response || !response.data) {
      throw new Error('Unsuccessful Response')
    }

    resolvedReturn = {
      result: 'success',
      data: {
        total: response.data.TotalCount,
        nextURL: response.data.Next,
        results: response.data.Results.map((result) => ({
          ID: result.ID.toString(),
          self: result.Self,
          albumID: result.AlbumID.toString(),
          isMustSee: result.IsMustSee,
          date: new Date(result.Date),
          sortOrder: result.SortOrder,
          thumbnailURL: `${API_URL + result.ThumbnailURL}?clientid=${clientID}`,
          thumbnailHeight: result.ThumbnailHeight,
          thumbnailWidth: result.ThumbnailWidth,
          standardURL: `${API_URL + result.StandardURL}?clientid=${clientID}`,
          standardHeight: result.StandardHeight,
          standardWidth: result.StandardWidth,
          nativeURL: `${API_URL + result.NativeURL}?clientid=${clientID}`,
          nativeHeight: result.NativeHeight,
          nativeWidth: result.NativeWidth,
          originalFileName: result.OriginalFileName,
        })),
      },
    }
  } catch (e) {
    resolvedReturn = handleError(ERROR_PATH, GENERIC_ERROR, e)
  }

  return Promise.resolve(resolvedReturn)
}
